/*
 * Copyright (c) 2023-2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import {HttpClient, HttpParams} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {environment} from '../../../environments/environment';
import {HelpInfo} from '../../model/helpInfo';

@Injectable({
  providedIn: 'root'
})
export class HelpInfoService {

  private helpInfoUrl: string;

  constructor(private http: HttpClient) {
    this.helpInfoUrl = environment.apiUrl + '/cpapi/helpinfo/v1';
  }

  public getHelpInfoByRoute(routeKey: string): Observable<any> {
    const params = new HttpParams()
    .set('key', routeKey);
    return this.http.get<HelpInfo[]>(this.helpInfoUrl + '/route', {params: params});
  }

  public saveHelpInfo(helpInfoDto: HelpInfo): Observable<any> {
    return this.http.post(this.helpInfoUrl + '/save', helpInfoDto);
  }
}
